var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.5013H4.16667M4.16667 5.5013H17.5M4.16667 5.5013V17.168C4.16667 17.61 4.34226 18.0339 4.65482 18.3465C4.96738 18.659 5.39131 18.8346 5.83333 18.8346H14.1667C14.6087 18.8346 15.0326 18.659 15.3452 18.3465C15.6577 18.0339 15.8333 17.61 15.8333 17.168V5.5013H4.16667ZM6.66667 5.5013V3.83464C6.66667 3.39261 6.84226 2.96868 7.15482 2.65612C7.46738 2.34356 7.89131 2.16797 8.33333 2.16797H11.6667C12.1087 2.16797 12.5326 2.34356 12.8452 2.65612C13.1577 2.96868 13.3333 3.39261 13.3333 3.83464V5.5013",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistTrashIcon);
export default __webpack_public_path__ + "static/media/wishlist-trash-icon.340a3a0119fd766fcfac53ab26ad3d1f.svg";
export { ForwardRef as ReactComponent };